import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Icon } from "@/components/formatters/MXPIcon";
import { TerraLink } from "../../component/TerraLink/TerraLink";
import { useScreenSize } from "../../utils/hooks/useScreenSize";
export interface IFeatureBlockQuote {
  eyebrow: string;
  header: string;
  quote?: string;
  attributionName?: string;
  attributionQualification?: string;
  button: {
    label: string;
    destination: string;
  };
}
interface FeatureBlockQuoteProps {
  presetTheme?: string;
  colorSetting?: string;
  componentStyles?: React.CSSProperties;
  featureBlockQuote: IFeatureBlockQuote;
}
const FeatureBlockQuote = t0 => {
  const $ = _c(37);
  const {
    presetTheme,
    colorSetting,
    componentStyles,
    featureBlockQuote
  } = t0;
  const {
    width
  } = useScreenSize();
  const t1 = presetTheme || "";
  let t2;
  if ($[0] !== colorSetting || $[1] !== t1) {
    t2 = ["flex gap-[160px] py-[60px] px-[108px] rounded border border-gray-m9", "t2-dark:border-white", "max-[1400px]:flex-col max-[1400px]:p-10 max-[1400px]:gap-10", "max-sm:flex-col max-sm:px-[37px] max-sm:py-[43px] max-sm:gap-[45px]", t1, colorSetting];
    $[0] = colorSetting;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = t2.join(" ");
  const t4 = featureBlockQuote?.eyebrow;
  let t5;
  if ($[3] !== t4) {
    t5 = <div className="text-yellow-m10 uppercase text-lg font-bold leading-7 tracking-[1.44px] mb-2 max-sm:text-sm max-sm:leading-[1.125rem] max-sm:tracking-[0.7px]">{t4}</div>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = featureBlockQuote?.header;
  let t7;
  if ($[5] !== t6) {
    t7 = <h3 className="text-[2.5rem] font-extrabold leading-[2.75rem] tracking-[0.03em] uppercase t2-dark:text-white max-[1400px]:text-[2.125rem] max-[1400px]:leading-[2.375rem] max-[1400px]:tracking-[0.9px] max-sm:text-[1.875rem] max-sm:leading-[2.375rem] max-sm:tracking-[0.9px]">{t6}</h3>;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t5 || $[8] !== t7) {
    t8 = <div className="flex-1 min-w-0">{t5}{t7}</div>;
    $[7] = t5;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = width < 600 ? 22 : 40;
  let t10;
  if ($[10] !== t9) {
    t10 = <div className="absolute top-1.5 -left-[60px] text-yellow-m10 z-[1] max-sm:-left-[36px]" aria-hidden="true"><Icon type="t2u-quotation" size={t9} /></div>;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = featureBlockQuote?.quote;
  let t12;
  if ($[12] !== t11) {
    t12 = <blockquote className="text-2xl font-normal leading-[2.375rem] mb-5 max-[1400px]:text-xl max-[1400px]:leading-7 max-sm:text-lg max-sm:leading-7">{t11}</blockquote>;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  const t13 = featureBlockQuote?.attributionName;
  let t14;
  if ($[14] !== t13) {
    t14 = <cite className="not-italic">— {t13}</cite>;
    $[14] = t13;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  const t15 = featureBlockQuote?.attributionQualification;
  let t16;
  if ($[16] !== t15) {
    t16 = <span className="before:content-['|'] before:mx-[5px] max-sm:before:content-[''] max-sm:before:mx-0 max-sm:text-sm max-sm:font-normal max-sm:leading-6 max-sm:tracking-[0.14px]">{t15}</span>;
    $[16] = t15;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] !== t14 || $[19] !== t16) {
    t17 = <div className="text-base font-semibold leading-[1.375rem] tracking-[0.02em] flex max-sm:flex-col">{t14}{t16}</div>;
    $[18] = t14;
    $[19] = t16;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  const t18 = featureBlockQuote?.button?.label;
  const t19 = featureBlockQuote?.button?.destination;
  let t20;
  if ($[21] !== t18 || $[22] !== t19) {
    t20 = <TerraLink label={t18} destination={t19} linkType="text" disableStyles={true} className="text-yellow-m10 no-underline border-0 shadow-none capitalize p-0 tracking-normal text-xl font-bold leading-[1.625rem] hover:underline hover:text-yellow-m10 focus:text-yellow-m10 active:text-yellow-m10" />;
    $[21] = t18;
    $[22] = t19;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  let t21;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Icon className="text-yellow-m10 flex items-center justify-center mt-[3px]" type="t2u-chevron-right" size={20} />;
    $[24] = t21;
  } else {
    t21 = $[24];
  }
  let t22;
  if ($[25] !== t20) {
    t22 = <div className="mt-5 self-end flex items-center gap-x-2.5 capitalize max-sm:mt-[50px] max-sm:-ml-[34px] max-sm:self-start">{t20}{t21}</div>;
    $[25] = t20;
    $[26] = t22;
  } else {
    t22 = $[26];
  }
  let t23;
  if ($[27] !== t10 || $[28] !== t12 || $[29] !== t17 || $[30] !== t22) {
    t23 = <div className="flex-[3_1_0%] min-w-0 relative flex flex-col max-[1400px]:ml-[60px] max-sm:ml-[34px]">{t10}{t12}{t17}{t22}</div>;
    $[27] = t10;
    $[28] = t12;
    $[29] = t17;
    $[30] = t22;
    $[31] = t23;
  } else {
    t23 = $[31];
  }
  let t24;
  if ($[32] !== componentStyles || $[33] !== t23 || $[34] !== t3 || $[35] !== t8) {
    t24 = <div className="max-w-[1440px] px-20 mx-auto w-full overflow-hidden max-[1400px]:px-10 max-sm:px-5"><div className={t3} style={componentStyles}>{t8}{t23}</div></div>;
    $[32] = componentStyles;
    $[33] = t23;
    $[34] = t3;
    $[35] = t8;
    $[36] = t24;
  } else {
    t24 = $[36];
  }
  return t24;
};
export default FeatureBlockQuote;